<template>
  <div class="layout-box" :class="{ layout2: property_data.type === 2 }">
    <!-- 不加key， 没有唯一值， 用index有可能更新不渲染 -->
    <div
      class="card-box"
      v-for="(item, index) in showData"
      :style=""
      :style="boxBg+`margin-bottom: ${property_data.margin_number}px;`"
      @click="jump(item.id)"
    >
      <div
        class="card-title ellipsis"
        :style="`background-color: ${property_data.subtitle_bg_color}`"
      >
        {{ item.title }}
      </div>
      <div class="card-main">
        <el-image class="card-image" fit="cover" :src="item.img_url"></el-image>
        <div class="sales-list" v-if="property_data.type === 1">
          <div
            class="item-sale"
            :style="`background-color:  ${property_data.sale_bg_color};`"
            v-for="(sale, inx) in item.sales"
            :key="inx"
          >
            <div class="ellipsis" :style="`color: ${property_data.sale_color}`">{{ sale }}</div>
          </div>
          <div class="sale-desc scale75">{{ item.sale_desc }}</div>
        </div>
      </div>
      <div class="btn-box">
        <div
          class="btn-left ellipsis"
          :style="
            `color: ${property_data.btn_lf_text_color}; background: linear-gradient(0deg, ${btn_lf_bg[0]}, ${btn_lf_bg[1]});`
          "
        >
          <span class="price-text">直播价:</span
          ><span class="price-number">{{ item.price }}</span>
        </div>
        <div
          class="btn-right"
          :style="
            `background: linear-gradient(0deg, ${btn_rt_bg[0]}, ${btn_rt_bg[1]});`
          "
        >
          <div
            class="commission-box ellipsis"
            :style="`color: ${property_data.btn_rt_text_color}`"
          >
            <span class="commission-text">佣金率:</span
            ><span class="commission">{{ item.commission }}%</span>
          </div>
          <div
            class="buy-text img-flex"
            :style="
              `color: ${property_data.btn_lf_text_color};background: linear-gradient(0deg, ${btn_lf_bg[0]}, ${btn_lf_bg[1]});`
            "
          >
            立即抢购<el-image style="height: 1.1rem; margin-left:0.4rem" src="https://mktv-in-cdn.mockuai.com/16401543454974860.png"></el-image>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {redirectURL} from '@/js/jump';
export default {
  name: "tms-active-day",
  props: ["config", "isEditorStatus", "pageData"],
  data() {
    return {};
  },
  computed: {
    app_type () {
      return this.pageData.app_type || 'seller'
    },
    boxBg() {
      let url = ''
      if(this.property_data.type === 2) return ''
      if (!this.property_data.background_url) {
        url = 'https://mktv-in-cdn.mockuai.com/16397295739421198.png'
      } else {
        url = this.property_data.background_url
      }
      return `background: url(${url}) 0 0 / 100% no-repeat;`;
    },
    showData() {
      if (this.listData.length) {
        return this.listData;
      }
      return this.notData;
    },
    notData() {
      const obj = {
        img_url:
          "https://mktv-in-cdn.mockuai.com/16397202064747389.png",
        title: "蔬小简综合7+谷物优D型片蔬小简综合7+谷物优D型片",
        price: 439.6,
        commission: "4",
        sales: [
          "销量第一名奖励2000元销量第一名奖励2000元",
          "销量第二名奖励2000元",
          "销量第三名奖励2000元",
          "销量第四名奖励2000元",
          "销量第五名奖励2000元"
        ],
        sale_desc: "参与排名条件：销量满1000单以上"
      };
      if (this.property_data.type === 2) {
        return [obj, obj];
      } else {
        return [obj];
      }
    },
    listData() {
      if (this.property_data.list && this.property_data.list.length) {
        return this.property_data.list;
      }
      return [];
    },
    btn_lf_bg() {
      const bg = this.property_data.btn_lf_bg;
      if (!Array.isArray(bg)) {
        return [];
      }
      return bg;
    },
    btn_rt_bg() {
      const bg = this.property_data.btn_rt_bg;
      if (!Array.isArray(bg)) {
        return [];
      }
      return bg;
    },
    property_data() {
      return this.config.property_data;
    }
  },
  methods: {
    jump(id) {
      if (this.isEditorStatus) {
        return;
      }
      redirectURL(String(id), this.app_type);
    },
  }
};
</script>

<style scoped>
.layout-box .card-box {
  padding: 2.5rem 2.4rem;
  padding-top: 3.4rem;
  background-color: #fff;
}

.layout2 {
  display: grid;
  grid-column-gap: 2.81%;
  grid-template-columns: 48.595% 48.595%;
  margin: 0 10px;
}

.layout2 .card-box {
  box-sizing: border-box;
  height: 17.3rem;
  padding: 0.4rem 0.9rem;
  margin-bottom: 10px;
}

.card-box {
  box-sizing: border-box;
  border-radius: 8px;
  width: 100%;
}

.layout2 .card-image {
  width: 10.3rem;
  height: 10.3rem;
  margin: 0.4rem auto;
}

.layout2 .card-title {
  font-size: 1.5rem;
  width: 12.5rem;
  height: 2.5rem;
  line-height: 2.5rem;
  margin: 0 auto;
  padding: 0 5px;
}

.card-title {
  font-size: 1.7rem;
  height: 3.3rem;
  line-height: 3.3rem;
  border-radius: 1.7rem;
  color: #fffefe;
  text-align: center;
  margin-bottom: 1.2rem;
  width: 15.6rem;
  padding: 0 8px;
}
.card-image {
  width: 15rem;
  height: 15rem;
  margin-bottom: 6px;
  flex-shrink: 0;
}
.sales-list {
  margin-bottom: 0.9rem;
  font-size: 1.1rem;
  width: 15.5rem;
  text-align: center;
}
.item-sale {
  text-align: left;
  box-sizing: border-box;
  width: 100%;
  height: 1.9rem;
  line-height: 1.9rem;
  border-radius: 4px;
  font-size: 1.1rem;
  padding-left: 0.7rem;
  margin-bottom: 4px;
  color: #fffefe;
}
.sale-desc {
  font-size: 12px;
  line-height: 12px;
  font-weight: 400;
}

.layout2 .btn-box {
  height: 5.04rem;
  transform: scale(0.55);
  transform-origin: 0 0;
  margin-left: 0.5rem;
}

.btn-box {
  width: 27rem;
  height: 5rem;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
}

.btn-left {
  width: 50%;
  height: 100%;
  box-sizing: border-box;
  text-align: center;
  line-height: 1;
  padding-top: 1.2rem;
  padding-left: 0.8rem;
  border-radius: 2.5rem 0 0 2.5rem;
}

.price-text {
  display: inline-block;
  font-size: 1.4rem;
  font-weight: 600;
  margin-right: 3px;
}
.price-number {
  font-size: 2.2rem;
  font-weight: bold;
}

.btn-right {
  width: 50%;
  height: 100%;
  text-align: center;
  box-sizing: border-box;
  border-radius: 0 2.5rem 2.5rem 0;
}

.commission-box {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}
.commission-text {
  display: inline-block;
  font-weight: 600;
  font-size: 1.4rem;
  line-height: 1;
  margin-right: 3.44px;
}
.commission {
  font-weight: bold;
  font-size: 1.7rem;
  line-height: 1;
}

.buy-text {
  width: 9.8rem;
  height: 2rem;
  line-height: 2rem;
  border-radius: 1rem;
  font-size: 1.4rem;
  text-align: center;
  margin: 0 auto;
}

.ellipsis {
  word-break: keep-all; /* 不换行 */
  white-space: nowrap; /* 不换行 */
  overflow: hidden;
  text-overflow: ellipsis;
}

.card-main {
  display: flex;
  justify-content: space-between;
}

.scale85 {
  width: 117.64%;
  transform: scale(0.85);
  transform-origin: 0 0;
}
.scale75 {
  width: 133.34%;
  transform: scale(0.75);
  transform-origin: 0 0;
}
.scale65 {
  transform: scale(0.65);
  transform-origin: 0 0;
}
.img-flex{
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
